import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '../dashboard_component';

function Admindashboard() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-blue-50/30">
      <Sidebar isCollapsed={isCollapsed} onToggle={handleToggle} />
      
      <div 
        className={`flex-1 transition-all duration-300 pt-16 lg:pt-8 ${
          isCollapsed ? 'lg:ml-20' : 'lg:ml-64'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          {/* Modern Header */}
          <div className="mb-8">
            <h1 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-700 bg-clip-text text-transparent mb-3">
              Welcome to CBTHost
            </h1>
            <p className="text-gray-600 text-lg max-w-2xl">
              Streamline your computer-based testing experience with our intuitive platform
            </p>
          </div>

          {/* Premium Usage Notification */}
          <div className="mb-10 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-2xl shadow-xl p-6 text-white">
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
              <div className="flex-1">
                <div className="flex items-center mb-3">
                  <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center mr-3">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-bold">Unlock Advanced Analytics & Reporting</h2>
                </div>
                <p className="text-blue-100 text-lg mb-4 max-w-3xl">
                  Subscribe to our <span className="font-semibold">Admin Analytics Service</span> to access cloud-hosted reporting, unlimited users under your account, and priority support.
                  Your analytics dashboard will be fully activated within <span className="font-bold">24 hours</span> after payment.
                </p>
                <div className="flex flex-wrap gap-3">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-green-300 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-blue-50">Cloud-hosted analytics dashboard</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-green-300 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-blue-50">Unlimited instructors/users</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-green-300 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-blue-50">Priority premium support</span>
                  </div>
                </div>
              </div>
              <button
                onClick={() => navigate('/cbt_creator/payment')}
                className="bg-white text-blue-600 hover:bg-blue-50 font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 whitespace-nowrap"
              >
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  View Subscription Plans
                </div>
              </button>
            </div>
          </div>

          {/* Action Cards Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mb-12">
            {/* Create Test Card */}
            <div 
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:border-blue-200 cursor-pointer transform hover:-translate-y-1"
              onClick={() => navigate('/cbt_creator/create_cbt')}
            >
              <div className="flex items-start space-x-6">
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-4 rounded-2xl shadow-lg group-hover:shadow-xl transition-shadow">
                  <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </div>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Create New Test</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    Design and customize computer-based tests with advanced question types and settings
                  </p>
                  
                  <div className="flex items-center text-blue-600 font-semibold group-hover:text-blue-700 transition-colors">
                    <span>Start Creating</span>
                    <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Participate in Test Card */}
            <div 
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:border-cyan-200 cursor-pointer transform hover:-translate-y-1"
              onClick={() => navigate('/participate/dashboard')}
            >
              <div className="flex items-start space-x-6">
                <div className="bg-gradient-to-br from-cyan-500 to-teal-500 p-4 rounded-2xl shadow-lg group-hover:shadow-xl transition-shadow">
                  <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                    </svg>
                  </div>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Participate in Test</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    Join existing tests as a participant with secure access and real-time monitoring
                  </p>
                  
                  <div className="flex items-center text-cyan-600 font-semibold group-hover:text-cyan-700 transition-colors">
                    <span>Join Test Now</span>
                    <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Stats/Features Section */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl">
            <div className="text-center p-6">
              <div className="bg-blue-100 w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Lightning Fast</h4>
              <p className="text-gray-600 text-sm">Quick test creation and participation</p>
            </div>
            
            <div className="text-center p-6">
              <div className="bg-green-100 w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Secure & Reliable</h4>
              <p className="text-gray-600 text-sm">Protected testing environment</p>
            </div>
            
            <div className="text-center p-6">
              <div className="bg-purple-100 w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Intuitive Interface</h4>
              <p className="text-gray-600 text-sm">Easy to use for all users</p>
            </div>
          </div>

          {/* Quick Links Footer */}
          <div className="mt-16 pt-8 border-t border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-2">Need Help?</h4>
                <p className="text-gray-600 text-sm">
                  Check our documentation or contact support for assistance
                </p>
              </div>
              <div className="flex space-x-4 mt-4 md:mt-0">
                <button
                  onClick={() => navigate('/payment')}
                  className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-6 py-2.5 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all"
                >
                  Manage Subscription
                </button>
                <button
                  onClick={() => navigate('/support')}
                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-6 py-2.5 rounded-xl font-semibold transition-colors"
                >
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admindashboard;

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Sidebar } from '../dashboard_component';

// function Admindashboard() {
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const navigate = useNavigate();

//   const handleToggle = () => {
//     setIsCollapsed(!isCollapsed);
//   };

//   return (
//     <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-blue-50/30">
//       <Sidebar isCollapsed={isCollapsed} onToggle={handleToggle} />
      
//       <div 
//         className={`flex-1 transition-all duration-300 pt-16 lg:pt-8 ${
//           isCollapsed ? 'lg:ml-20' : 'lg:ml-64'
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
//           {/* Modern Header */}
//           <div className="mb-10">
//             <h1 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-700 bg-clip-text text-transparent mb-4">
//               Welcome to CBTHost
//             </h1>
//             <p className="text-gray-600 text-lg max-w-2xl">
//               Streamline your computer-based testing experience with our intuitive platform
//             </p>
//           </div>

//           {/* Action Cards Grid */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl">
//             {/* Create Test Card */}
//             <div 
//               className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:border-blue-200 cursor-pointer transform hover:-translate-y-1"
//               onClick={() => navigate('/cbt_creator/create_cbt')}
//             >
//               <div className="flex items-start space-x-6">
//                 <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-4 rounded-2xl shadow-lg group-hover:shadow-xl transition-shadow">
//                   <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
//                     <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
//                     </svg>
//                   </div>
//                 </div>
                
//                 <div className="flex-1">
//                   <h3 className="text-2xl font-bold text-gray-900 mb-3">Create New Test</h3>
//                   <p className="text-gray-600 mb-6 leading-relaxed">
//                     Design and customize computer-based tests with advanced question types and settings
//                   </p>
                  
//                   <div className="flex items-center text-blue-600 font-semibold group-hover:text-blue-700 transition-colors">
//                     <span>Start Creating</span>
//                     <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                     </svg>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Participate in Test Card */}
//             <div 
//               className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:border-cyan-200 cursor-pointer transform hover:-translate-y-1"
//               onClick={() => navigate('/participate/dashboard')}
//             >
//               <div className="flex items-start space-x-6">
//                 <div className="bg-gradient-to-br from-cyan-500 to-teal-500 p-4 rounded-2xl shadow-lg group-hover:shadow-xl transition-shadow">
//                   <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
//                     <svg className="w-5 h-5 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
//                     </svg>
//                   </div>
//                 </div>
                
//                 <div className="flex-1">
//                   <h3 className="text-2xl font-bold text-gray-900 mb-3">Participate in Test</h3>
//                   <p className="text-gray-600 mb-6 leading-relaxed">
//                     Join existing tests as a participant with secure access and real-time monitoring
//                   </p>
                  
//                   <div className="flex items-center text-cyan-600 font-semibold group-hover:text-cyan-700 transition-colors">
//                     <span>Join Test Now</span>
//                     <svg className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                     </svg>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Stats/Features Section */}
//           <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl">
//             <div className="text-center p-6">
//               <div className="bg-blue-100 w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4">
//                 <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
//                 </svg>
//               </div>
//               <h4 className="font-semibold text-gray-900 mb-2">Lightning Fast</h4>
//               <p className="text-gray-600 text-sm">Quick test creation and participation</p>
//             </div>
            
//             <div className="text-center p-6">
//               <div className="bg-green-100 w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4">
//                 <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
//                 </svg>
//               </div>
//               <h4 className="font-semibold text-gray-900 mb-2">Secure & Reliable</h4>
//               <p className="text-gray-600 text-sm">Protected testing environment</p>
//             </div>
            
//             <div className="text-center p-6">
//               <div className="bg-purple-100 w-12 h-12 rounded-2xl flex items-center justify-center mx-auto mb-4">
//                 <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
//                 </svg>
//               </div>
//               <h4 className="font-semibold text-gray-900 mb-2">Intuitive Interface</h4>
//               <p className="text-gray-600 text-sm">Easy to use for all users</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Admindashboard;